module.exports = __webpack_public_path__ + "5ece04226e31e53ccb990d568392da65.png";


//////////////////
// WEBPACK FOOTER
// ./assets/panacek-rest-no-support.png
// module id = sfeO
// module chunks = 0